export const environment = {
  production: false,
  seed: 'uscdev-application-session.seed.json'
};
